export default __webpack_public_path__ + "static/media/ic_agreement_minutes.5e238d58.svg";